<template>
    <v-dialog v-model="dialog" width="538" @click:outside="closeModal">
        <v-card class="custom-card pb-120" rounded="0">
            <v-toolbar flat color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold">{{
                $t("Assign Zone")
            }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            </v-toolbar>
            <v-card-text class="pt-5">
   
                <div class="text-h6 mt-5 black--text">Choose from existing Zones</div>
                <v-row class="text-center d-flex">
                    <v-col lg="6" md="6" sm="6" xs="6">
                        <label class="subtitle-1 font-weight-medium"
                          >Select Farm Location

                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>
                              {{ $t("animal.generalInfoFrom.assignZone") }}
                            </span>
                          </v-tooltip></label
                        >
                        <div>
                          <v-select
                            outlined
                            dense
                            v-model="animal.locationId"
                            :items="farmLocationFilter"
                            item-text="address"
                            item-value="id"
                            attach
                            placeholder="Select Farm Location"
                            @change="fetchLocationZones(animal.locationId)"
                          >
                          </v-select>
                        </div>
                      </v-col>
                      <v-col lg="6" md="6" sm="6" xs="6">
                        <label class="subtitle-1 font-weight-medium"
                          >Assign Zone<v-tooltip
                            top
                            color="black"
                            max-width="350"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>
                              {{ $t("animal.generalInfoFrom.assignZone") }}
                            </span>
                          </v-tooltip></label
                        >
                        <template v-slot:prepend-item>
                          <v-list-item>
                            <v-list-item-content>
                              <v-text-field
                                outlined
                                dense
                                v-model="zoneSearchTerm"
                                placeholder="Search"
                                @input="searchFruits"
                              >
                              </v-text-field>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <div>
                          <v-select
                            outlined
                            dense
                            v-model="animal.zoneId"
                            :items="farmZones"
                            item-text="geofenceName"
                            item-value="id"
                            attach
                            placeholder="Select Zone"
                          >
                            <template v-slot:prepend-item>
                              <v-list-item>
                                <v-list-item-content v-if="locationSelected">
                                  <v-text-field
                                    outlined
                                    dense
                                    v-model="zoneSearchTerm"
                                    placeholder="Search"
                                    @input="searchFruits"
                                  >
                                  </v-text-field>
                                  <div>
                                    <v-icon style="color: #00bd73"
                                      >mdi-plus</v-icon
                                    >
                                    <a
                                      href="#"
                                      @click="showPrimaryGeofenceDialog = true"
                                      >Create New Zone</a
                                    >
                                  </div>
                                </v-list-item-content>
                                <v-list-item-content v-else>
                                      <div
                                        class="ml-1 mt-2" style="color: rgb(255, 18, 18)"
                                      >
                                        Please select location first.
                                      </div>
                                       
                                    </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>
                          </v-select>
                        </div>
                      </v-col>
                </v-row>
                <!-- <v-divider></v-divider>
                <v-row class="text-center d-flex mt-5">
                    <v-col cols="8">
                        <v-text-field v-model="newZonename" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-btn color="primary" depressed @click="$router.push({name: 'FarmZones', query: { name: newZonename}})">Create New</v-btn>
                    </v-col>
                </v-row>
               -->
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined depressed @click="closeModal">Cancel</v-btn>
                    <v-btn color="primary" :disabled="!animal.zoneId" depressed @click="assignZone">Confirm selection</v-btn>
                </v-card-actions>
            </v-card-text>
        </v-card>
        <NewZone
      v-if="showPrimaryGeofenceDialog"
      :farmId="Number(farmId)"
      :locationId="Number(animal.locationId)"
      :dialogI="showPrimaryGeofenceDialog"
      @zone:added="onZoneAdded"
      @newZoneClosed="showPrimaryGeofenceDialog = false"
    />
    </v-dialog>
    
  </template>
  
  <script>
  import loadingMixin from "@/mixins/LoadingMixin";
  import generalMixin from "@/mixins/GeneralMixin";
  import gql from "graphql-tag"
  import NewZone from "./NewZone.vue";
  import { assignGroupToZone } from "@/graphql/Farm.gql"
  import { assignAnimalToZone } from "@/graphql/Animals.gql"
  import FarmService from "@/_services/farmService";
  
  export default {
    apollo: {
        zones: {
            query: gql`query {
                primaryFarm{
                    id
                    farmName,
                    GeoFences {
                        id
                        geofenceName
                    }
                }
            }`,
            update: (data) =>  data.primaryFarm.GeoFences
        }
    },
    components: {
        NewZone,
    },
    computed: {
        dialog() {
            return this.dialogU;
        },
        loadingGQL() {
            return this.$apollo.loading 
        },
        farmLocationFilter() {
        if(this.selectedFarmLocations){
            return this.selectedFarmLocations?.map((item) => {
            return {
            id: item?.id,
            address: item?.farmData?.farmName + " / " + item.address,
            };
        });
        }else {
            return [];
        }
        },
    },
    watch: {
        loadingGQL: {
            handler(v) {
                if(v) {
                    this.startLoading()
                }else{
                    this.stopLoading()
                }
            }
        }
    },
    data() {
      return {
        valid: true,
        zone: null,
        newZonename: "",
        animal : {
            locationId:  '',
            zoneId: ''
        },
        farmZones: [],
        selectedFarmLocations: [],
        zoneSearchTerm: '',
        zonesCopy: [],
        showPrimaryGeofenceDialog: false,
        locationSelected: []
      };
    },
    methods: {
        searchFruits() {
      if (!this.zoneSearchTerm) {
        this.farmZones = this.zonesCopy;
      } else {
        this.farmZones = this.zonesCopy.filter((zone) => {
          return zone.geofenceName
            ?.toLowerCase()
            .includes(this.zoneSearchTerm.toLowerCase());
        });
      }
    },
    async onZoneAdded(zoneName) {
      this.farmZones = await FarmService.getAllZonesByLocationId(
                Number(this.animal.locationId)
            );
        this.farmZones = this.farmZones.data;
      this.animal.zoneId = this.farmZones.find(
        (zone) => zoneName.toLowerCase() == zone.geofenceName.toLowerCase()
      ).id;
    },
        async fetchLocationZones(locationId) {
            this.startLoading()
            this.farmZones = await FarmService.getAllZonesByLocationId(
                Number(locationId)
            );
            this.farmZones = this.farmZones.data;
            this.filterZones = this.farmZones;
            this.zonesCopy = this.farmZones
            this.locationSelected = locationId ? true : false;
            this.stopLoading()
        },
        async fetchLocations(farmId) {
            this.farmZones = [];
            this.locationSelected = false;
            const yourQuery = gql`
            query framLocations($farmId: Float!) {
                farmLocations(farmId: $farmId) {
                id
                address
                farmData {
                    farmName
                }
                }
            }
            `;
            let farmLocationRes = await this.$apollo
            .query({
                query: yourQuery,
                variables: {
                farmId: Number(farmId)
            },
            })

            this.selectedFarmLocations  = farmLocationRes.data.farmLocations
 

        },
        assignZone() {
            this.startLoading()
            const mutationData = {}
            if(this.assignType == 'goal'){
                mutationData.mutation = assignGroupToZone
                mutationData.variables=  {
                    assignGroupToZoneInput: {
                        groupId: parseInt(this.group.id), 
                        geofenceZoneId: parseInt(this.animal.zoneId)
                    }
                }
            }else{
                mutationData.mutation = assignAnimalToZone
                mutationData.variables =  {
                    assignAnimalToZone: {
                        animalId: parseInt(this.group.id), 
                        zoneId: parseInt(this.animal.zoneId),
                        locationId: Number(this.animal.locationId)
                    }
                }
            }

            this.$apollo.mutate(mutationData)
            .then(res => {
                console.log(res)
                this.closeModal(true)
                this.stopLoading()
            })
            .catch( () => {
                this.stopLoading()
            })
        },
        closeModal(success=null) {
            this.$emit("modal-closed", success);
        },
    },
    async mounted() {
        await this.fetchLocations(this.farmId)
    },
    props: {
        dialogU: {
            type: Boolean,
            required: true,
        },
        group: {
            type: Object,
            required: true,
        },
        assignType: { // Can be animal or goal
            type: String
        },
        farmId: {
            type: String
        }
    },
    mixins: [loadingMixin, generalMixin]
  };
  </script>
